import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Layout,
  Menu,
  Button,
  Grid,
} from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DashboardOutlined,
  CodeSandboxOutlined,
  TagsOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  BarChartOutlined,
  LeftOutlined,
  ShoppingOutlined,
} from '@ant-design/icons';

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const AdminPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const [collapsed, setCollapsed] = useState(false);
  const { user, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!loading && (!user || user.role !== 'admin')) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  if (loading || !user || user.role !== 'admin') {
    return null;
  }

  const menuItems = [
    { key: '/admin', icon: <DashboardOutlined />, label: 'Bosh sahifa' },
    { key: '/admin/products', icon: <CodeSandboxOutlined />, label: 'Mahsulotlar' },
    { key: '/admin/categories', icon: <TagsOutlined />, label: 'Kategoriyalar' },
    { key: '/admin/sellers', icon: <TeamOutlined />, label: 'Sotuvchilar' },
    { key: '/admin/regions', icon: <EnvironmentOutlined />, label: 'Regionlar' },
    { key: '/admin/orders', icon: <ShoppingOutlined />, label: 'Buyurtmalar' },
    { key: '/admin/statistics', icon: <BarChartOutlined />, label: 'Statistika' },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (!screens.md) {
      setCollapsed(true);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="md"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100,
        }}
      >
        <div style={{ height: 64, margin: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>Admin paneli</div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          onClick={handleMenuClick}
          items={menuItems}
        />
      </Sider>
      <Layout style={{ marginLeft: collapsed ? 0 : (screens.md ? 200 : 0), transition: 'margin-left 0.2s' }}>
        <Header style={{ padding: 0, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 16 }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <Button
            icon={<LeftOutlined />}
            onClick={() => navigate('/')}
          >
            Do&apos;konga qaytish
          </Button>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: '#fff',
            borderRadius: 8,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default AdminPage;
